<!-- Role Upgradation Request Table Content -->
<app-table
          [columns]="roleUpgradeColumns"
          [data]="roleUpgradeData"
          [scrollHeight]="'400px'"
          [loading]="loading"
          [pagination]="roleUpgradePagination"
          [emptyMessage]="roleUpgradeEmptyMessage"
          [striped]="true"
          [bordered]="true"
          [hoverable]="true"
          [showExportButton]="showExportButton"
          (export)="onExport()"
          (pageChange)="onRoleUpgradePageChange($event)"
          (pageSizeChange)="onRoleUpgradePageSizeChange($event)"
        >
          <!-- Custom Status Column with Chip Design -->
          <ng-template #roleUpgradeStatusCell let-row>
            <span class="status-chip" 
                  [class.status-chip--pending]="isStatusPending(row.status)" 
                  [class.status-chip--approved]="row.status?.toLowerCase() === 'granted' || row.status?.toLowerCase() === 'approved'"
                  [class.status-chip--rejected]="row.status?.toLowerCase() === 'rejected'">
              {{ row.status || 'N/A' }}
            </span>
          </ng-template>

          <!-- Custom Action Column for Role Upgradation -->
          <ng-template #roleUpgradeActionCell let-row>
            <div class="action-cell-wrapper">
              <button 
                class="action-btn" 
                (click)="toggleActionDropdown($event, row)"
                [class.active]="isDropdownOpen(row)"
                type="button"
              >
                <span>Action</span>
              </button>
              
              <!-- Dropdown Menu -->
              <div 
                class="action-dropdown-menu" 
                *ngIf="isDropdownOpen(row)" 
                [attr.data-dropdown-id]="getRowId(row)"
                (click)="$event.stopPropagation()"
              >
                <ul class="dropdown-list">
                  <li class="dropdown-item">
                    <button 
                      class="dropdown-link"
                      type="button"
                      (click)="handleView(row)"
                    >
                      View
                    </button>
                  </li>
                  <li class="dropdown-item">
                    <button 
                      class="dropdown-link" 
                      type="button"
                      [disabled]="isStatusProcessed(row.status)"
                      (click)="!isStatusProcessed(row.status) && handleRoleUpgradeAction('approve', row)"
                    >
                      Approve
                    </button>
                  </li>
                  <li class="dropdown-item">
                    <button 
                      class="dropdown-link dropdown-link--danger" 
                      type="button"
                      [disabled]="isStatusProcessed(row.status)"
                      (click)="!isStatusProcessed(row.status) && handleRoleUpgradeAction('reject', row)"
                    >
                      Reject
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </ng-template>
</app-table>

<!-- View Request Modal -->
<app-modal
  [(visible)]="isViewModalOpen"
  header="Role Upgrade Request Details"
  [closable]="true"
  [width]="'520px'"
  [showFooter]="false"
  (onClose)="closeViewModal()"
>
  <div *ngIf="selectedViewRow" class="view-modal-body">
    <div class="view-modal-row">
      <span class="view-modal-label">User Name</span>
      <span class="view-modal-value">{{ selectedViewRow.userName || '—' }}</span>
    </div>
    <div class="view-modal-row">
      <span class="view-modal-label">Employee ID</span>
      <span class="view-modal-value">{{ selectedViewRow.employeeId || '—' }}</span>
    </div>
    <div class="view-modal-row">
      <span class="view-modal-label">Job Title</span>
      <span class="view-modal-value">{{ selectedViewRow.jobTitle || '—' }}</span>
    </div>
    <div class="view-modal-row">
      <span class="view-modal-label">Current Role</span>
      <span class="view-modal-value">{{ selectedViewRow.currentRole || '—' }}</span>
    </div>
    <div class="view-modal-row">
      <span class="view-modal-label">Requested Date</span>
      <span class="view-modal-value">{{ selectedViewRow.requestedDate || '—' }}</span>
    </div>
    <div class="view-modal-row">
      <span class="view-modal-label">Status</span>
      <span class="view-modal-value">
        <span class="status-chip"
          [class.status-chip--pending]="isStatusPending(selectedViewRow.status)"
          [class.status-chip--approved]="selectedViewRow.status?.toLowerCase() === 'granted' || selectedViewRow.status?.toLowerCase() === 'approved'"
          [class.status-chip--rejected]="selectedViewRow.status?.toLowerCase() === 'rejected'"
        >
          {{ selectedViewRow.status || 'N/A' }}
        </span>
      </span>
    </div>
  </div>
</app-modal>
